import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';

@Component({
  selector: 'app-cropper-image',
  templateUrl: './cropper-image.component.html',
  styleUrls: ['./cropper-image.component.scss']
})
export class CropperImageComponent implements OnInit {

  imageChangedEvent: any = '';
  croppedImage: any = '';
  objectImage!: any;
  aspectRatio: number = 1;

  constructor(@Inject(MAT_DIALOG_DATA) public data, private sanitizer: DomSanitizer,
  private dialogRef: MatDialogRef<CropperImageComponent>) { }

  // `data` es el evento del input a secas (recorte cuadrado: logos, espacios,
  // perfil) o `{ img, aspectRatio }` cuando quien abre el diálogo pide otra proporción
  ngOnInit(): void {
    if(this.data.img) {
      this.imageChangedEvent = this.data.img;
      this.aspectRatio = this.data.aspectRatio ?? 1;
    } else {
      this.imageChangedEvent = this.data;
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.base64);
    this.objectImage = event;
    // event.blob can be used to upload the cropped image
  }

  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  async saveImage() {
    // Comprimir la imagen antes de guardar
    const compressedBase64 = await this.compressImage(this.objectImage.base64);
    const compressedObject = { ...this.objectImage, base64: compressedBase64 };


    this.dialogRef.close({
      pathUrl: this.sanitizer.bypassSecurityTrustUrl(compressedBase64),
      object: compressedObject
    });
  }

  // Función para comprimir la imagen base64
  private compressImage(base64: string, maxWidth: number = 1920, maxHeight: number = 1080, quality: number = 0.7): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Redimensionar si la imagen es muy grande
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = width * ratio;
          height = height * ratio;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convertir a JPEG con calidad reducida para mejor compresión
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(compressedBase64);
      };
      img.src = base64;
    });
  }

}
